export default __webpack_public_path__ + "static/media/1.8809e99e.png";